import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { usePostReadAll } from '~/react-query-hooks/events/use-event-alerts/useEventAlerts';
import { appPaths } from '~/routes/app-paths';

import * as S from './Header.styles';

export interface HeaderProps {
  activeButtonIndex: number;
  onButtonClick: (index: number) => void;
  onClose: () => void;
}

export const Header = ({
  activeButtonIndex,
  onButtonClick,
  onClose,
}: HeaderProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();
  const { mutate: readAllAlerts } = usePostReadAll();

  const handleNavigateToAlerts = () => {
    onClose();
    navigate(appPaths.alerts);
  };

  // TODO: update to get unread count from store
  const unreadCount = 12;
  const buttonLabels = [
    t('dropdown.all'),
    t('dropdown.unread', { count: unreadCount }),
  ];

  return (
    <S.HeaderWrapper>
      <S.TitleAndButtonRow>
        <S.Title>{t('dropdown.title')}</S.Title>
        <S.ButtonContainer>
          <Button
            variant="empty"
            size="xsmall"
            iconName="CheckDouble"
            onClick={() => readAllAlerts()}
          />
          <Button
            variant="empty"
            size="xsmall"
            iconName="Expand"
            onClick={handleNavigateToAlerts}
          />
        </S.ButtonContainer>
      </S.TitleAndButtonRow>
      <S.StyledButtonGroup
        labels={buttonLabels}
        activeIndex={activeButtonIndex}
        onClick={onButtonClick}
      />
    </S.HeaderWrapper>
  );
};
